<p-select [options]="options" [(ngModel)]="ngModel" optionLabel="{{ optionLabel }}" (onChange)="change($event)">
    <ng-template let-option pTemplate="item">
        <div
            [ngClass]="{ 'disabled-option': option.disabled }"
            [pTooltip]="option.disabled ? option.disabledTooltip || disabledTooltip : option.tooltip ? option.tooltip : ''"
            [tooltipPosition]="tooltipPosition"
            (click)="option.disabled && $event.stopPropagation()"
        >
            {{ option[optionLabel] }}
        </div>
    </ng-template>
</p-select>
